import { z } from "zod";
import { DbCreateInputOmit } from "../helpers";

const AssetDeleteScheduleStatus = z.enum(["InProgress", "Pending"]);
export type AssetDeleteScheduleStatus = z.infer<typeof AssetDeleteScheduleStatus>;


export const AssetDeleteSchedule = z.object({
    id: z.string(),
    path: z.string(),
    createdAt: z.date(),
    deleteAt: z.date(),
    isFolder: z.boolean(),
    status: AssetDeleteScheduleStatus,
});

export type AssetDeleteSchedule = z.infer<typeof AssetDeleteSchedule>;

export type AssetDeleteScheduleDbInput = DbCreateInputOmit<AssetDeleteSchedule>;

